// extracted by mini-css-extract-plugin
export default {"PrescriptionPhotos":"PrescriptionPhotos_PrescriptionPhotos__dCSaZ","permitWrap":"PrescriptionPhotos_permitWrap__nIlIX"};